export function isExternal(link) {
  // Match internal links (relative links)
  const internalRegex = /^(?!www\.|(?:http|ftp)s?:\/\/|[A-Za-z]:\\|\/\/).*$/i

  // Match special links (URIs, anchors)
  const specialLinkRegex = /^(mailto|tel|#[\s\S]*$)/i

  if (specialLinkRegex.test(link)) {
    // Special link: consider external
    return true
  } else if (internalRegex.test(link)) {
    // Relative link: consider internal
    return false
  } else {
    // External link
    return true
  }
}
